/**
 * Logs layout du header / bandeau au chargement.
 *
 * Actif automatiquement dans l’éditeur de thème Shopify (aperçu).
 * Sinon : ?debug_header=1  ou  localStorage.debug_header = "1"
 *         ou ancre #debug_header
 */
(function () {
  function isDebugHeaderEnabled() {
    try {
      if (new URLSearchParams(window.location.search).get('debug_header') === '1') {
        return { ok: true, reason: 'query debug_header=1' };
      }
      if (window.location.hash === '#debug_header') {
        return { ok: true, reason: 'hash #debug_header' };
      }
      if (window.localStorage.getItem('debug_header') === '1') {
        return { ok: true, reason: 'localStorage debug_header' };
      }
      if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
        return { ok: true, reason: 'Shopify.designMode (éditeur de thème)' };
      }
    } catch (_) {}
    return { ok: false, reason: null };
  }

  var gate = isDebugHeaderEnabled();
  if (!gate.ok) {
    try {
      if (!sessionStorage.getItem('header_debug_hint_once')) {
        sessionStorage.setItem('header_debug_hint_once', '1');
        console.info(
          '[header-debug] Traces désactivées sur cette page. Pour les voir : ajoutez ?debug_header=1 à l’URL, ou dans la console : localStorage.setItem("debug_header","1") puis rechargez. Ou ouvrez la boutique dans l’éditeur de thème (activation auto). Filtre console : header-debug'
        );
      }
    } catch (_) {}
    return;
  }

  function init() {
    console.log('[header-debug] Mode actif —', gate.reason);

    const root = document.documentElement;
    const cssKeys = [
      '--header-height',
      '--announcement-bar-height',
      '--header-is-visible',
      '--announcement-bar-is-sticky',
    ];

    const prevCss = {};
    cssKeys.forEach(function (k) {
      prevCss[k] = getComputedStyle(root).getPropertyValue(k).trim();
    });
    console.log('[header-debug] CSS :root (initial)', Object.assign({}, prevCss));

    const cssObs = new MutationObserver(function () {
      cssKeys.forEach(function (k) {
        const v = getComputedStyle(root).getPropertyValue(k).trim();
        if (v !== prevCss[k]) {
          console.log('[header-debug] CSS :root changement', k, {
            avant: prevCss[k],
            après: v,
            ms: performance.now().toFixed(1),
          });
          prevCss[k] = v;
        }
      });
    });
    cssObs.observe(root, { attributes: true, attributeFilter: ['style'] });

    function attachResizeObserver(label, el) {
      if (!el) {
        console.warn('[header-debug] élément introuvable:', label);
        return;
      }
      var ro = new ResizeObserver(function (entries) {
        entries.forEach(function (e) {
          console.log('[header-debug] ResizeObserver', label, {
            h: e.contentRect.height.toFixed(2),
            ms: performance.now().toFixed(1),
          });
        });
      });
      ro.observe(el);
      console.log('[header-debug] ResizeObserver attaché:', label);
    }

    var headerObserverEl =
      document.querySelector('.shopify-section--header height-observer') ||
      document.querySelector('#shopify-section-header height-observer') ||
      document.querySelector('height-observer[variable="header"]');
    attachResizeObserver('header height-observer', headerObserverEl);

    var announcementEl =
      document.querySelector('.shopify-section--announcement-bar height-observer') ||
      document.querySelector('height-observer[variable="announcement-bar"]');
    attachResizeObserver('announcement height-observer', announcementEl);

    var xHeader = document.querySelector('x-header.header');
    if (xHeader) {
      var clsObs = new MutationObserver(function () {
        console.log('[header-debug] classes x-header', xHeader.className, performance.now().toFixed(1) + 'ms');
      });
      clsObs.observe(xHeader, { attributes: true, attributeFilter: ['class'] });
      console.log('[header-debug] surveillance classes x-header');
    } else {
      console.warn('[header-debug] x-header.header introuvable');
    }

    console.log('[header-debug] Astuce désactivation : localStorage.removeItem("debug_header")');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
